import { CobaltSearchField } from '@cae/cobalt-react/components/search-field';
import { useInvoicesFilter } from '@features/invoices/contexts/filter/useInvoicesFilter';
import { useSearchField } from '@shared/hooks/use-search-field/useSearchField';
import * as React from 'react';

import type { InvoicesSearchProps } from './InvoicesSearch.types';

import styles from './InvoicesSearch.module.css';

const InvoicesSearch = React.memo(
  ({ disabled = false }: Readonly<InvoicesSearchProps>): React.ReactElement => {
    const { filters, setFilters } = useInvoicesFilter();

    const { localValue, handleChange, handleClear } = useSearchField({
      value: filters.searchText,
      onSearch: (searchText: string) => setFilters({ searchText }),
    });

    return (
      <CobaltSearchField
        hasClear={true}
        placeholder="Search by transaction number, etc."
        value={localValue}
        onChange={handleChange}
        onClear={handleClear}
        disabled={disabled}
        className={styles.invoicesSearch}
        data-testid="invoices-search"
      />
    );
  }
);

InvoicesSearch.displayName = 'InvoicesSearch';
export { InvoicesSearch };
